import type { WalletMfaManagement } from '@/features/wallet-mfa/use-wallet-mfa-management';
import { useIsMobile } from '@/global-hooks/use-is-mobile';
import { BottomSheet, Modal, theme } from '@/shared/design-system';

import { useWalletTotpDialogController } from './use-wallet-totp-dialog-controller';
import { WalletTotpSetupView } from './wallet-totp-dialog-content';

type WalletTotpSetupDialogProps = {
  open: boolean;
  management: WalletMfaManagement;
  onClose: () => void;
};

export const WalletTotpSetupDialog = ({
  open,
  management,
  onClose,
}: WalletTotpSetupDialogProps) => {
  const isMobile = useIsMobile();
  const controller = useWalletTotpDialogController({ open, management, onClose });
  const dismissible = !controller.pending;
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen && dismissible) controller.close();
  };
  const content = (
    <WalletTotpSetupView
      isMobile={isMobile}
      pending={controller.pending}
      material={controller.material}
      code={controller.code}
      keySaved={controller.keySaved}
      error={controller.error}
      copiedAnnouncement={controller.copiedAnnouncement}
      otpRef={controller.otpRef}
      onCodeChange={controller.changeCode}
      onKeySavedChange={controller.setKeySaved}
      onCopy={() => void controller.copySecret()}
      onRetry={controller.prepareSetup}
    />
  );

  if (isMobile) {
    return (
      <BottomSheet
        open={open}
        onOpenChange={handleOpenChange}
        title="Set up Wallet MFA"
        showClose={dismissible}
        hideHandle={!dismissible}
        maxHeight="calc(100dvh - 56px)"
      >
        {content}
      </BottomSheet>
    );
  }

  return (
    <Modal
      open={open}
      onOpenChange={handleOpenChange}
      title="Set up Wallet MFA"
      showClose={dismissible}
      maxWidth={600}
      gap={theme.spacing[24]}
      contentPadding={theme.spacing[0]}
    >
      {content}
    </Modal>
  );
};
